export enum BusStopReportNameOptions {
    BUS_STOP_REPORT = 'BUS_STOP_REPORT',
    PASSENGER_COUNT_REPORT = 'PASSENGER_COUNT_REPORT'
}
